var map = {
	"./--icon-bg-box-outline-1.svg": 6372,
	"./--icon-bg-circle-solid.svg": 8362,
	"./--icon-bg-unboxed.svg": 6695,
	"./WarnTriangleFilled.svg": 3888,
	"./add-to-cart-green.svg": 5894,
	"./alert-white.svg": 5270,
	"./arrow-down.svg": 5464,
	"./attention.svg": 6770,
	"./box-outline.svg": 8038,
	"./cart.svg": 6074,
	"./checkmark-1.svg": 3589,
	"./checkmark-2.svg": 1158,
	"./checkmark.svg": 5171,
	"./chevron-double-left.svg": 1977,
	"./chevron-double-right-1.svg": 5690,
	"./chevron-double-right.svg": 4,
	"./chevron-down-1.svg": 1332,
	"./chevron-down-blue.svg": 9999,
	"./chevron-down.svg": 9582,
	"./chevron-up.svg": 1141,
	"./chevron-white-down.svg": 5266,
	"./chevron-white-up.svg": 6593,
	"./circle-outline.svg": 8461,
	"./close.svg": 4180,
	"./compass-drafting.svg": 3098,
	"./complete.svg": 3874,
	"./copy.svg": 5063,
	"./download-pdf.svg": 909,
	"./ellipsis-menu.svg": 3591,
	"./ellipsis-v.svg": 4900,
	"./expand.svg": 5320,
	"./fullscreen.svg": 3368,
	"./help.svg": 4049,
	"./icon-admin-settings.svg": 4453,
	"./icon-attention-white.svg": 7410,
	"./icon-cart copy 6.svg": 9991,
	"./icon-certificate-1.svg": 1779,
	"./icon-certificate-2.svg": 5680,
	"./icon-certificate.svg": 585,
	"./icon-check-green.svg": 6750,
	"./icon-check-white-1.svg": 8418,
	"./icon-check-white.svg": 3228,
	"./icon-checkbox-active.svg": 273,
	"./icon-checkbox-default.svg": 8431,
	"./icon-close-green.svg": 5570,
	"./icon-close-grey.svg": 4040,
	"./icon-close-orange.svg": 5919,
	"./icon-close-red.svg": 7218,
	"./icon-close.svg": 4664,
	"./icon-configuration.svg": 9466,
	"./icon-copy.svg": 7971,
	"./icon-delivery-default.svg": 9452,
	"./icon-delivery-fast.svg": 9615,
	"./icon-delivery-medium.svg": 52,
	"./icon-delivery-slow.svg": 4278,
	"./icon-download.svg": 5900,
	"./icon-edit-1.svg": 5918,
	"./icon-edit-line.svg": 4479,
	"./icon-edit.svg": 3152,
	"./icon-favorite.svg": 4328,
	"./icon-filter.svg": 6754,
	"./icon-info-white.svg": 9144,
	"./icon-label.svg": 334,
	"./icon-list.svg": 1868,
	"./icon-panel-open.svg": 59,
	"./icon-phone.svg": 4928,
	"./icon-refresh-1.svg": 7519,
	"./icon-refresh-black.svg": 1131,
	"./icon-refresh.svg": 2573,
	"./icon-reset-1.svg": 9080,
	"./icon-reset-grey.svg.svg": 2895,
	"./icon-reset.svg": 4673,
	"./icon-search.svg": 1512,
	"./icon-select-dot.svg": 3578,
	"./icon-select-square.svg": 8172,
	"./icon-status-attention.svg": 8519,
	"./icon-status-conflict.svg": 3177,
	"./icon-status-edit-1.svg": 4625,
	"./icon-status-edit-2.svg": 1845,
	"./icon-status-edit.svg": 1047,
	"./icon-status-info-1.svg": 3325,
	"./icon-status-info.svg": 7579,
	"./icon-status-preselected-1.svg": 1723,
	"./icon-status-preselected-2.svg": 984,
	"./icon-status-preselected-3.svg": 5225,
	"./icon-status-preselected.svg": 3249,
	"./icon-status-success.svg": 6588,
	"./icon-support-chat.svg": 9164,
	"./icon-support-mail.svg": 1099,
	"./icon-support.svg": 89,
	"./icon-toggle-view-1.svg": 2484,
	"./icon-toggle-view.svg": 9678,
	"./icon-tooltip-info.svg": 4290,
	"./icon-view.svg": 6167,
	"./info-circle.svg": 8281,
	"./info.svg": 284,
	"./logo-blue.svg": 4946,
	"./logo.svg": 6997,
	"./menue-dots-edit-1.svg": 3930,
	"./menue-dots-edit-2.svg": 9513,
	"./menue-dots-edit-3.svg": 4008,
	"./menue-dots-edit-4.svg": 9079,
	"./menue-dots-edit-blue.svg": 7453,
	"./menue-dots-edit.svg": 9860,
	"./more-options.svg": 1366,
	"./plus-gray.svg": 8964,
	"./reguest.svg": 3213,
	"./request.svg": 8923,
	"./reset-red.svg": 4359,
	"./support.svg": 165,
	"./toggle-2D-active.svg": 1150,
	"./toggle-2D-default.svg": 7423,
	"./toggle-3D-active.svg": 9367,
	"./toggle-3D-default.svg": 7460,
	"./toggle-picture-active.svg": 1844,
	"./toggle-picture-default.svg": 10,
	"./toggle-view.svg": 418,
	"./writing.svg": 3848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;